export default __webpack_public_path__ + "static/media/easyMenuIcon.0c6703a9.svg";